import { useMediaQuery } from '@uhg-abyss/web/hooks/useMediaQuery';
import { Card } from '@uhg-abyss/web/ui/Card';
import { Carousel, Slide } from '@uhg-abyss/web/ui/Carousel';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Text } from '@uhg-abyss/web/ui/Text';
import { t } from 'i18next';

import { shouldUseGehaV2Styling } from '../../utils/gehaThemeUtils';
import { StyledDiv, desktopOnly, phoneOnly } from '../ConstantsStyles';
import { LinkWithTracking } from '../LinkWithTracking/LinkWithTracking';
import { makeAllSlidesAriaHidden } from '../Utils/a11yUtils/a11yUtils';
import {
  CarouselCssStyles,
  SlideCssStyles,
} from './OnlineSpecialtyGroup.Style';

export const OnlineSpecialtyGroupCard = ({ marketPlaceObj }) => {
  const desktopScreen = useMediaQuery(desktopOnly);
  const phoneScreen = useMediaQuery(phoneOnly);
  const cardCssStyles = {
    'abyss-card-root': {
      padding: '0px',
      height: desktopScreen ? '323px' : phoneScreen ? '300px' : '250px',
      width: phoneScreen ? '100%' : '98%',
      display: 'flex',
      borderColor: '#F3F3F3F3',
      borderRadius: '4px',
      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.09)',
      flexDirection: 'column',
      '.card-section': {
        padding: '30px 24px',
      },
      '.card-section:first-of-type': {
        padding: '16px 24px',
        flexGrow: 1,
      },
    },
  };

  const isGEHAV2 = shouldUseGehaV2Styling();

  const slides = marketPlaceObj.map((group) => (
    <Slide css={SlideCssStyles} key={group.dntTitle}>
      <div css={{ padding: 0 }}>
        <Card css={cardCssStyles}>
          <StyledDiv className="card-section">
            <Heading
              data-auto-testid={`${group.dntTitle}-heading`}
              data-testid={`${group.dntTitle}-heading`}
              level={2}
              size="xs"
            >
              {t(group.dntTitle)}
            </Heading>
            <Text color={isGEHAV2 ? '$core.color.brand.100' : ''}>
              {t(group.description)}
            </Text>
          </StyledDiv>
          <StyledDiv
            className="card-section"
            css={{
              borderTop: '0px !important',
              paddingBottom: '30px',
            }}
          >
            <Layout.Group
              css={{
                justifyContent: 'space-between',
              }}
            >
              <LinkWithTracking
                after={<IconSymbol icon="open_in_new" />}
                analyticsInfo={{
                  location: 'body:online specialty groups',
                  destinationUrl: `${group.linkUrl}`,
                }}
                css={{
                  lineHeight: '15px',
                }}
                data-auto-testid={`${group.dntTitle}`}
                data-testid={`${group.dntTitle}`}
                isStandardAnchor
                onClick={() => window.open(group.linkUrl)}
                size="$md"
              >
                {t(group.linkText)}
              </LinkWithTracking>

              <img
                alt={group.dntTitle}
                src={group.iconUrl}
                style={{
                  width: '100px',
                  backgroundImage: 'none',
                }}
              />
            </Layout.Group>
          </StyledDiv>
        </Card>
      </div>
    </Slide>
  ));

  return (
    <Carousel
      css={CarouselCssStyles}
      data-auto-testid="online-specialty-groups-carousel"
      data-testid="online-specialty-groups-carousel"
      key={marketPlaceObj.length}
      label=""
      nextSlideOnClick={() => makeAllSlidesAriaHidden()}
      prevSlideOnClick={() => makeAllSlidesAriaHidden()}
      slideIndexOnClick={() => makeAllSlidesAriaHidden()}
      slides={slides}
      slidesPerView={desktopScreen ? 3 : 1}
    />
  );
};
